export default "<router-outlet></router-outlet>\r\n<!--Insercion commit-->\r\n<!--Insercion commit-->\r\n"